<script setup lang="ts">
import { computed, ref } from 'vue'
import BSelect from '@/components/common/bSelect.vue'
import { useUserStore } from '@/config/store/userStore';
import { userApi } from '@/services/api';

const userStore = useUserStore()

const options = computed(() => {
  if (!userStore.user?.firmList?.length) return []
  return userStore.user.firmList.map(firm => ({
    _id: firm._id,
    display: firm.company,
    value: firm._id,
  }))
})

const selectedFirm = computed({
  get: () => {
    return userStore.user?.firm
  },
  set: (value) => {
    userApi.updateUser(userStore.user.user._id, { _firmId: value._id }).promise.then(() => {
      window.location.reload()
    })
  },
})

</script>

<template>

  <BSelect v-model="selectedFirm" class="max-w-full md:w-60" bg="base" :options="options" />
</template>
